import apiServices from "../apiServices";


export const coursesApi = {
  getCourses: async (params = {}) => {
    const {
      page = 1,
      limit = 10,
      search = '',
      sortOrder = 'asc',
      category = '',
      level = '',  // course level
      format = '',  // course format
      isActive
    } = params;

    const queryParams = new URLSearchParams();
    queryParams.append('page', page.toString());
    queryParams.append('limit', limit.toString());

    if (search) queryParams.append('search', search);
    if (sortOrder) queryParams.append('sortOrder', sortOrder);
    if (category) queryParams.append('category', category);
    if (level !== '') queryParams.append('level', level.toString());
    if (format !== '') queryParams.append('format', format.toString());
    if (isActive !== undefined) queryParams.append('isActive', isActive.toString());

    const response = await apiServices.get(`/api/v1/courses/admin?${queryParams.toString()}`);
    return response.data;
  },
  getCoursesInsideLesson: async (params = {}) => {
    const {
      search = '',
      sortOrder = 'asc',
      category = '',
      level = '',  // course level
      format = ''  // course format
    } = params;

    const queryParams = new URLSearchParams();

    if (search) queryParams.append('search', search);
    if (sortOrder) queryParams.append('sortOrder', sortOrder);
    if (category) queryParams.append('category', category);
    if (level !== '') queryParams.append('level', level.toString());
    if (format !== '') queryParams.append('format', format.toString());

    const response = await apiServices.get(`/api/v1/courses?${queryParams.toString()}`);
    return response.data;
  },
  getCourseById: async (id) => {
    const response = await apiServices.get(`/api/v1/courses/${id}`);
    return response.data;
  },
  createCourse: async (data) => {
    const response = await apiServices.post(`/api/v1/courses`, data);
    return response.data;
  },
  updateCourse: async (id, data) => {
    const response = await apiServices.patch(`/api/v1/courses/${id}`, data);
    return response.data;
  },
  deleteCourse: async (id) => {
    const response = await apiServices.delete(`/api/v1/courses/${id}`);
    return response.data;
  },
  // Search courses with advanced filters
  searchCourses: async (searchParams) => {
    const {
      query = '',
      category = '',
      level = '',
      format = '',
      page = 1,
      limit = 10,
      sortBy = 'createdAt',
      sortOrder = 'desc',
      dateFrom = '',
      dateTo = '',
      isActive
    } = searchParams;

    const queryParams = new URLSearchParams();
    queryParams.append('page', page.toString());
    queryParams.append('limit', limit.toString());

    if (query) queryParams.append('search', query);
    if (category) queryParams.append('category', category);
    if (level !== '') queryParams.append('level', level.toString());
    if (format !== '') queryParams.append('format', format.toString());
    if (sortBy) queryParams.append('sortBy', sortBy);
    if (sortOrder) queryParams.append('sortOrder', sortOrder);
    if (dateFrom) queryParams.append('dateFrom', dateFrom);
    if (dateTo) queryParams.append('dateTo', dateTo);
    if (isActive !== undefined) queryParams.append('isActive', isActive.toString());

    const response = await apiServices.get(`/api/v1/courses?${queryParams.toString()}`);
    return response.data;
  },
  // add existing lesson to course
  addExistingLessonToCourse: async (courseId, lessonId) => {
    const response = await apiServices.post(`/api/v1/courses/${courseId}/lessons`, { lessonId });
    return response.data;
  },
  // remove lesson from course
  removeLessonFromCourse: async (courseId, lessonId) => {
    const response = await apiServices.delete(`/api/v1/courses/${courseId}/lessons/${lessonId}`);
    return response.data;
  },
  // get all lessons in a course
  getAllLessonsInCourse: async (courseId) => {
    const response = await apiServices.get(`/api/v1/courses/${courseId}/lessons`);
    return response.data;
  },
  // create new lesson and add to course
  createNewLessonAndAddToCourse: async (courseId, lessonData) => {
    const response = await apiServices.post(`/api/v1/courses/${courseId}/lessons/create`, lessonData);
    return response.data;
  },
  // update lesson in course
  updateLessonInCourse: async (courseId, lessonId, lessonData) => {
    const response = await apiServices.patch(`/api/v1/courses/${courseId}/lessons/${lessonId}`, lessonData);
    return response.data;
  },
  // get course with lessons and HSL video links
  getCourseWithLessonsAndHSLVideoLinks: async (courseId) => {
    const response = await apiServices.get(`/api/v1/courses/${courseId}/lessons/with-videos`);
    return response.data;
  },
};

